import React from "react";
import { FaAsterisk } from "react-icons/fa";
import Waste_img from "../../Images/waste.jpeg";
import { useEffect } from "react";
const Waste = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto py-12 font-Poppins">
        <div className="flex flex-col lg:flex-row justify-between items-start">
          <div className="w-full lg:w-[48%]">
            <h2 className="text-2xl lg:text-4xl font-semibold py-4">
              Waste Management
            </h2>
            <p className="text-lg py-4">
              We are all encouraged to love and commit to looking after our
              environment. One of how we could make our contributions to the
              environment is by embracing the 3Rs of waste management — Reduce,
              Reuse, Recycle
            </p>
            <p className="text-lg">
              It costs a lot to dispose of waste, and reducing these costs is
              part of our offer. Many items found in the skip might be helpful
              to neighbors and charities. It is good practice to check whether
              the items to be disposed of are recyclable or whether others in
              need might require them before arranging for them to be recycled.
            </p>
          </div>
          <div className="w-full lg:w-[48%]">
            <img src={Waste_img} alt="waste" className="rounded-md" />
          </div>
        </div>
        <h3 className="pt-16 font-semibold text-2xl">
          Most Popular Ways to Manage Waste Include:
        </h3>
        <div className="flex gap-2  font-medium justify-start items-center mt-6 mb-2">
          <FaAsterisk />
          Recycling
        </div>
        <div className="flex gap-2  font-medium justify-start items-center mt-6 mb-2">
          <FaAsterisk />
          Incineration
        </div>
        <div className="flex gap-2 font-medium justify-start items-center mt-6 mb-2">
          <FaAsterisk />
          Landfill
        </div>
        <div className="flex gap-2 font-medium justify-start items-center mt-6 mb-2">
          <FaAsterisk />
          Biological Processing
        </div>
        <div className="flex gap-2 justify-start items-center mt-6 mb-2">
          <FaAsterisk />
          Animal Feed
        </div>
        <p className="pt-4 font-medium">
          All the above require one treatment or the other, which is expensive
          in both an economic and environmental.
        </p>
        <p className="font-medium py-4">We can help you with the 3Rs</p>
        <p className="font-medium pb-2">
          If you have unused items or waste that you want to dispose of, we will
          examine and see if they have alternative use elsewhere before
          recycling them.
        </p>
      </div>
    </div>
  );
};

export default Waste;
